/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BulkEditResultResponseResultsInnerError
 */
export interface BulkEditResultResponseResultsInnerError {
    /**
     * 
     * @type {string}
     * @memberof BulkEditResultResponseResultsInnerError
     */
    op?: string;
    /**
     * 
     * @type {string}
     * @memberof BulkEditResultResponseResultsInnerError
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof BulkEditResultResponseResultsInnerError
     */
    message: string;
}

/**
 * Check if a given object implements the BulkEditResultResponseResultsInnerError interface.
 */
export function instanceOfBulkEditResultResponseResultsInnerError(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "code" in value;
    isInstance = isInstance && "message" in value;

    return isInstance;
}

export function BulkEditResultResponseResultsInnerErrorFromJSON(json: any): BulkEditResultResponseResultsInnerError {
    return BulkEditResultResponseResultsInnerErrorFromJSONTyped(json, false);
}

export function BulkEditResultResponseResultsInnerErrorFromJSONTyped(json: any, ignoreDiscriminator: boolean): BulkEditResultResponseResultsInnerError {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'op': !exists(json, 'op') ? undefined : json['op'],
        'code': json['code'],
        'message': json['message'],
    };
}

export function BulkEditResultResponseResultsInnerErrorToJSON(value?: BulkEditResultResponseResultsInnerError | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'op': value.op,
        'code': value.code,
        'message': value.message,
    };
}

